var map = {
	"./bg_chart.png": "9a81",
	"./bg_list_esnj.png": "b64d",
	"./bg_more_video.png": "81db",
	"./bg_njtgxc_tit.png": "826f",
	"./bg_ranking.png": "61241",
	"./bg_title_nhrd.png": "3c8f",
	"./btn_switch_left.png": "7713",
	"./btn_switch_right.png": "b890",
	"./btn_tab.png": "f4a2b",
	"./btn_tab_c.png": "68a9",
	"./dk_dot.png": "4d47",
	"./dk_line.png": "095d",
	"./farm-work.png": "34b9",
	"./icon_escz.png": "ad8c",
	"./icon_fbr.png": "a1ac",
	"./icon_njzl.png": "2057",
	"./icon_num_bf.png": "9f85",
	"./icon_num_jx.png": "1bc9",
	"./icon_num_nh.png": "2a0a",
	"./icon_num_nz.png": "2d41",
	"./icon_num_sp.png": "3d75",
	"./icon_num_wx.png": "ad56",
	"./icon_ranking_num.png": "26cb",
	"./icon_video_list_bf.png": "9aaa",
	"./num-default.png": "ca6f",
	"./num_1.png": "fa07",
	"./num_2.png": "338b",
	"./num_3.png": "fc07",
	"./pic_nj_mrt.png": "ef1b",
	"./pic_ranking_one.png": "39af",
	"./pic_ranking_three.png": "a3dc",
	"./pic_ranking_two.png": "ce9c",
	"./pic_sp_mrt.png": "50a0",
	"./video/icon_bf.png": "d25f",
	"./video/icon_bf_c.png": "7fb5b",
	"./video/icon_jy.png": "ce79",
	"./video/icon_jy_c.png": "4721",
	"./video/icon_syj.png": "7a65",
	"./video/icon_syj_c.png": "8c29",
	"./video/icon_video_cloase.png": "021a",
	"./video/icon_video_lb.png": "6e40",
	"./video/icon_video_lt.png": "a7c8",
	"./video/icon_video_qp_c.png": "3b61",
	"./video/icon_video_qp_s.png": "871a",
	"./video/icon_video_rb.png": "515d",
	"./video/icon_video_rt.png": "34a7",
	"./video/icon_voice.png": "1fd9",
	"./video/icon_voice_c.png": "968a",
	"./video/icon_voice_s.png": "f01e",
	"./video/icon_voice_s_n.png": "fa3c",
	"./video/icon_xyj.png": "7d1a",
	"./video/icon_xyj_c.png": "e482",
	"./video/icon_zt.png": "7930",
	"./video/icon_zt_c.png": "4d38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "87b8";